import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 3.495h17.849v3.246H2.5V3.495zm0 6.49h17.849v3.246H2.5V9.986zm0 9.737h9.358v-3.246H2.5v3.246zm14.8-.627v-4.1a4 4 0 103.999 4.1h-4z" }));
export default createSvgIcon(iconPath, "Scheduled Delist");
//# sourceMappingURL=StatusScheduledDelistV2Icon.js.map